<template>
  <div id="lister-payout-quote">
    <div class="booking-schedule">
              <div class="production-period font-mdish" v-if="data.requested_from != data.requested_to"><strong class="wt-sb">Production Period:</strong> {{ data.date_range_formatted }}</div>
              <div class="production-period font-mdish" v-if="data.requested_from == data.requested_to"><strong class="wt-sb">Production Date:</strong> {{ data.date_range_formatted }}</div>
              <table class="costs-table">
                <tr>
                  <th>Day</th>
                  <th>
                    {{ data.type === 'recce' ? 'Arrival Time' : 'Call Times'}}
                  </th>
                </tr>

                <tr v-for="day in data.days_and_times_formatted">
                  <td>{{ day.day }}</td>
                  <td>{{ day.time }}</td>
                </tr>

                <tr v-if="data.type == 'recce'">
                  <td>Duration of recce</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Brand</td>
                  <td>{{data.hirer_name}}</td> 
                </tr>

                <tr>
                  <td>Production Type</td>
                  <td>{{data.production_type_label}}</td> 
                </tr>

                <tr v-if="data.type != 'recce'">
                  <td>Crew Size</td>
                  <td>{{data.number_of_people}}</td> 
                </tr>

                <tr>
                  <td>Additional Notes</td>
                  <td>{{ data.notes }}</td> 
                </tr>

                <tr>
                  <td>Payout less APS and Merchant Fees</td>
                  <td>{{data.current_quote_total_formatted}}</td> 
                </tr>
              </table>

              <div class="note" v-if="data.type != 'recce'">
                Note: these funds will be paid into your Stripe account 24hrs prior to the production start time.
              </div>
              <div class="note" v-if="data.type == 'recce'" >
                Note: these funds will be paid into your Stripe account after the completion of the reece.
              </div>
          </div>

    <!-- <table class="costs-table"> -->
<!--      <tr-->
<!--          v-for="item in data.current_quote_for_user.user_line_items"-->
<!--          :class="{'no-cost': !item.total}"-->
<!--      >-->
<!--        <td class="item">-->
<!--          {{ item.label }}-->
<!--        </td>-->
<!--        <td class="quantity">-->
<!--          &nbsp;-->
<!--        </td>-->
<!--        <td class="cost">-->
<!--          ${{ item.total_formatted }}-->
<!--        </td>-->
<!--      </tr>-->
<!--      <tr class="subtotal">-->
<!--        <td class="item" colspan="2">Sub total</td>-->
<!--        &lt;!&ndash; td class="quantity">&nbsp;</td &ndash;&gt;-->
<!--        <td class="cost">-->
<!--          {{ data.current_quote_total_formatted }}-->
<!--        </td>-->
<!--      </tr>-->
<!--      <tr class="subtotal">-->
<!--        <td class="item" colspan="2">GST</td>-->
<!--        &lt;!&ndash; td class="quantity">&nbsp;</td &ndash;&gt;-->
<!--        <td class="cost">-->
<!--          &mdash;-->
<!--        </td>-->
<!--      </tr>-->
      <!-- <tr>
        <td class="item" colspan="2">
          Location hire less APS and Merchant Fees
        </td> -->
        <!-- td class="quantity">&nbsp;</td -->
        <!-- <td class="cost">
          {{ data.current_quote_total_formatted }}
        </td>
      </tr>
    </table> -->
  </div> 
</template>

<script>
import BaseModal from '../../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>
